import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { convertFields, getFieldDataTypeValue } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import CustomRadio from '../../common/ui/CustomRadio';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class DirectusCollectionsUpdate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    fieldDatatypes: [],
    directusCollection: '',
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, tableName, version } = match.params;
    await actions.loadExternalDatabaseForDirectus({ projectId, externalDbUuid, version });
    const { externalDbDirectus } = this.props.dataConnector;
    if (externalDbDirectus) {
      this.setState({ directusCollection: this.props.dataConnector.externalDbDirectus });
    }
  }

  handleCancel = () => {
    const { match, history } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    history.push(`/data-connector/${version}/v/${projectId}/directus-edit/${externalDbUuid}`);
  };

  handleSave = async (values, selectedPrimaryKey) => {
    const { fieldDatatypes, directusCollection } = this.state;
    const { actions, match } = this.props;
    const { projectId, externalDbUuid, version, tableName } = match.params;

    const { completeData, setting, name } = directusCollection;
    const newArray = completeData['tables'];
    const selectedData = newArray.find((table) => table.name === tableName);
    const fieldData = selectedData.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });
    const newResult = convertFields(result);
    const data = {
      version,
      collectionNames: tableName,
      collectionTitle: values.collectionTitle,
      orgCollectionName: tableName,
      fields: newResult,
      projectId,
      setting,
      externalDatabaseId: externalDbUuid,
      name,
      selectedPrimaryKey,
    };
    await actions.updateCollectionForDirectus(data);
    await actions.updateExternalDatabaseForDirectus({
      projectId,
      externalDbUuid,
      newResult,
      version,
      collectionName: tableName,
      collectionTitle: values.collectionTitle,
      selectedPrimaryKey,
    });
    this.handleCancel();
  };
  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }

    const { match, dataConnector } = this.props;
    const {
      loadExternalDatabaseForDirectusPending,
      getSchemaForDirectusCollectionPending,
      updateCollectionForDirectusPending,
      updateExternalDatabaseForDirectusPending,
    } = dataConnector;
    if (loadExternalDatabaseForDirectusPending || getSchemaForDirectusCollectionPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={
                loadExternalDatabaseForDirectusPending || getSchemaForDirectusCollectionPending
              }
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    const { tableName } = match.params;
    const { completeData } = this.state.directusCollection;
    const tables = completeData ? completeData['tables'] : null;
    const selectedCollection = tables ? tables.find((table) => table.name === tableName) : null;
    const fieldData = selectedCollection ? selectedCollection.fields : null;
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard title={'Update Collection  via Directus'} icon={'collection'}>
          {' '}
          <Formik
            initialValues={{
              collectionTitle: selectedCollection.collectionTitle || selectedCollection.name,
            }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Directus collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.name}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                      value={selectedCollection.name}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                        value={values.collectionTitle}
                        onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>Types</th>
                          {selectedCollection.selectedPrimaryKey != 'id' && (
                            <th style={{ width: '12%' }}>Primary Key</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td>{fieldName}</td>
                            <td>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                            {selectedCollection.selectedPrimaryKey !== 'id' && (
                              <td style={{ width: '12%' }}>
                                {selectedCollection.selectedPrimaryKey ? (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={fieldName}
                                        className="form-check-input"
                                        checked={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? true
                                            : false
                                        }
                                        disabled={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? false
                                            : true
                                        }
                                      />
                                    </CustomRadio>
                                  </div>
                                ) : (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={fieldName}
                                        className="form-check-input"
                                        checked={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? true
                                            : false
                                        }
                                        disabled={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? false
                                            : true
                                        }
                                      />
                                    </CustomRadio>
                                  </div>
                                )}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Cancel"
                      type="button"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Save Collection"
                      onClick={() => this.handleSave(values, selectedCollection.selectedPrimaryKey)}
                      disabled={
                        updateCollectionForDirectusPending ||
                        updateExternalDatabaseForDirectusPending
                      }
                    >
                      <i className="wb webconnect-save-regular"></i> Update
                      <CustomLoader
                        loading={
                          updateCollectionForDirectusPending ||
                          updateExternalDatabaseForDirectusPending
                        }
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectusCollectionsUpdate);
